<template>
    <div class="body">
        <div class="title">
            <span class="tab" @click="dangjianguanli">党建管理</span>
            <span class="tab active">党员管理</span>
            <!-- 面包屑导航区域 -->
            <div class="fansk">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/shouye' }" class="dsadf">
                        <span class="dsadf">首页</span>
                    </el-breadcrumb-item>
                    <el-breadcrumb-item>党员管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>

        <div class="btnsearch">
            <div class="left">
                <el-button type="primary" icon="el-icon-plus" size="medium" @click="fabuhuodongguanli">发布</el-button>
            </div>
            <div class="csass"></div>
            <div class="right">
                <el-form :inline="true">
                    <!-- <el-form-item>
                        <el-select placeholder="会员状态" v-model="Query.is_status" @change="Discountsearch" style="min-width: 168px;width: 168px" clearable>
                            <el-option name="selected" :value="0" label="全部 "></el-option>
                            <el-option name="selected" :value="1" label="下架 "></el-option>
                            <el-option name="selected" :value="2" label="上架 "></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item>
                        <el-date-picker type="date" value-format="yyyy-MM-dd" @change="Discountsearch" v-model="Query.create_date" placeholder="发布日期">
                        </el-date-picker>
                    </el-form-item>
                    <!-- <el-form-item>
                        <el-select placeholder="活动类型" v-model="Query.space" @change="Discountsearch" style="min-width: 168px; width: 168px" clearable>
                            <el-option v-for="item in optiontype" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item>
                        <el-select placeholder="活动状态" v-model="Query.act_status" @change="Discountsearch" style="min-width: 168px; width: 168px" clearable>
                            <el-option v-for="item in act_status" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input placeholder="排序/跳转链接/链接说明 " v-model="Query.keyword" @input="Discountsearch" style="min-width: 168px; width: 336px">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="成员列表" name="0">
                <vxe-table :data="tableData" border stripe resizable highlight-cell highlight-hover-row max-height="750" class="mytable-scrollbar" show-overflow keep-source align="center" :highlight-current-column="true">
                    <vxe-table-column field="id" title="ID" width="80">
                    </vxe-table-column>
                    <vxe-table-column field="username" title="姓名" width="100">
                    </vxe-table-column>
                    <vxe-table-column field="sex" title="性别" width="100">
                        <template slot-scope="scope">
                            {{ scope.row.sex == 1 ? '男':'女' }}
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="logo" title="头像" width="100">
                        <template slot-scope="scope">
                            <img v-if="scope.row.logo" :src="$ReturnImgUrl(scope.row.logo)" alt="" style="width: 50px; height: 50px;">
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="mobile" title="手机号" width="120">
                    </vxe-table-column>
                    <vxe-table-column field="email" title="邮箱" min-width="200">
                    </vxe-table-column>
                    <vxe-table-column field="area_name" title="地区" min-width="100">
                    </vxe-table-column>
                    <vxe-table-column field="idcard" title="身份证号" width="200">
                    </vxe-table-column>
                    <vxe-table-column field="education" title="学历" width="100">
                        <template slot-scope="scope">
                            {{ getEducationListName(scope.row.education) }}
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="work_unit" title="工作单位" min-width="200">
                    </vxe-table-column>
                    <vxe-table-column field="role" title="职务" width="120">
                    </vxe-table-column>
                    <vxe-table-column field="status" title="状态" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 1">通过</span>
                            <span v-else-if="scope.row.status == 2">驳回</span>
                            <span v-else>申请</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column title="操作" min-width="180" fixed="right">
                        <!-- <template slot-scope="scope">
              <div v-if="scope.row.status == 0" class="rou">
                <button @click="shenhe(scope.row, 1)" class="dsaggg mr">
                  通过
                </button>
                <button @click="shenhe(scope.row, 2)" class="dsaggg">
                  驳回
                </button>
              </div>
            </template> -->
                    </vxe-table-column>
                </vxe-table>

                <div v-if="pageshow">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page" :page-sizes="[10]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </el-tab-pane>

            <el-tab-pane label="申请列表" name="1">
                <vxe-table :data="tableData2" border stripe resizable highlight-cell highlight-hover-row max-height="750" class="mytable-scrollbar" show-overflow keep-source align="center" :highlight-current-column="true">
                    <vxe-table-column field="id" title="ID" width="80">
                    </vxe-table-column>
                    <vxe-table-column field="username" title="姓名" width="100">
                    </vxe-table-column>
                    <vxe-table-column field="sex" title="性别" width="100">
                        <template slot-scope="scope">
                            {{ scope.row.sex == 1 ? '男':'女' }}
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="logo" title="头像" width="100">
                        <template slot-scope="scope">
                            <img v-if="scope.row.logo" :src="$ReturnImgUrl(scope.row.logo)" alt="" style="width: 50px; height: 50px;">
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="mobile" title="手机号" width="120">
                    </vxe-table-column>
                    <vxe-table-column field="email" title="邮箱" min-width="200">
                    </vxe-table-column>
                    <vxe-table-column field="area_name" title="地区" min-width="100">
                    </vxe-table-column>
                    <vxe-table-column field="idcard" title="身份证号" width="200">
                    </vxe-table-column>
                    <vxe-table-column field="education" title="学历" width="100">
                        <template slot-scope="scope">
                            {{ getEducationListName(scope.row.education) }}
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="work_unit" title="工作单位" min-width="200">
                    </vxe-table-column>
                    <vxe-table-column field="role" title="职务" width="120">
                    </vxe-table-column>
                    <vxe-table-column field="status" title="状态" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 1">通过</span>
                            <span v-else-if="scope.row.status == 2">驳回</span>
                            <span v-else>申请</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column title="操作" min-width="180" fixed="right">
                        <!-- <template slot-scope="scope">
              <div v-if="scope.row.status == 0" class="rou">
                <button @click="shenhe(scope.row, 1)" class="dsaggg mr">
                  通过
                </button>
                <button @click="shenhe(scope.row, 2)" class="dsaggg">
                  驳回
                </button>
              </div>
            </template> -->
                    </vxe-table-column>
                </vxe-table>

                <div v-if="pageshow2">
                    <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page="query2.page" :page-sizes="[10]" layout="total, sizes, prev, pager, next, jumper" :total="total2">
                    </el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import {
        actList,
        businessassociationDel,
        huoDongSetstatusval,
    } from "@/api/tiezi";

    import { adminInfo } from "@/api/login";

    export default {
        name: "index",
        components: {},
        data() {
            return {
                activeName: '0',

                Query: {
                    token: sessionStorage.getItem("token"),
                    create_date: "",
                    space: "",
                    act_status: null,
                    keyword: "",
                    page: 1,
                    pagesize: 10,
                    is_status: 0,
                },

                query: {
                    token: sessionStorage.getItem("token"),
                    bus_id: '',
                    page: 1,
                    pagesize: 10
                },
                tableData: [],
                pageshow: true,
                total: null,

                query2: {
                    token: sessionStorage.getItem("token"),
                    bus_id: '',
                    page: 1,
                    pagesize: 10
                },
                tableData2: [],
                pageshow2: true,
                total2: null,

                act_status: [{
                    label: "全部",
                    value: "",
                }, {
                    label: "报名未开始",
                    value: "0",
                }, {
                    label: "报名进行中",
                    value: "1",
                }, {
                    label: "报名已结束",
                    value: "2",
                }, {
                    label: "活动已报满",
                    value: "3",
                }, {
                    label: "活动进行中",
                    value: "4",
                }, {
                    label: "活动已结束",
                    value: "5",
                }, ],

                educationList: [{
                    name: '小学',
                    code: 1
                }, {
                    name: '初中',
                    code: 2
                }, {
                    name: '高中',
                    code: 3
                }, {
                    name: '大专',
                    code: 4
                }, {
                    name: '本科',
                    code: 5
                }, {
                    name: '硕士',
                    code: 6
                }, {
                    name: '博士',
                    code: 7
                }, ],
            };
        },
        created() {
            this.getList();
            this.getList2();
        },
        methods: {
            Discountsearch() {
                // this.cur_page = 1;
                // this.pageshow = false; // 让分页隐藏
                // this.$nextTick(() => {
                //     // 重新渲染分页
                //     this.pageshow = true;
                // });
            },

            getList() {
                // businessassociation_members(this.query).then(({ data: res }) => {
                //     this.tableData = res.list;
                //     this.total = res.total;
                // })
            },
            handleSizeChange(val) {
                this.query.pagesize = val
                this.getList();
            },
            handleCurrentChange(val) {
                this.query.page = val
                this.getList();
            },

            getList2() {
                // businessassociation_members_applying(this.query2).then(({ data: res }) => {
                //     this.tableData2 = res.list;
                //     this.total2 = res.total;
                // })
            },
            handleSizeChange2(val) {
                this.query2.pagesize = val
                this.getList2();
            },
            handleCurrentChange2(val) {
                this.query2.page = val
                this.getList2();
            },

            getEducationListName(value) {
                return (this.educationList.find(item => item.code == value) || {}).name || "";
            },

            dangjianguanli() {
                this.$router.push("/dangjianguanli");
            },
            fabuhuodongguanli() {
                this.$router.push("/fabudangyuanguanli");
            },
        },
    };
</script>

<style scoped lang="less">
    .bianji {
        width: 78px;
        height: 37px;
        opacity: 1;
        border: 1px solid rgba(61, 154, 255, 0.5);
        border-radius: 2px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #3d9aff;
        letter-spacing: 0px;
        background: white;
        margin-right: 10px;

        &.red {
            color: #f56c6c;
            border-color: #f56c6c;
        }
    }

    .body {
        display: flex;
        flex-direction: column;

        .title {
            opacity: 1;
            font-size: 30px;
            font-family: PingFang SC, PingFang SC-Heavy;
            font-weight: 800;
            text-align: left;
            color: #2e2e2e;
            letter-spacing: 0px;
            margin-bottom: 35px;
            display: flex;
            flex-direction: row;
            align-items: center;

            .tab {
                margin-right: 20px;
                color: #999;
                cursor: pointer;

                &.active {
                    color: #2e2e2e;
                    cursor: default;

                    &:hover {
                        text-decoration: none;
                    }
                }

                &:hover {
                    color: #2e2e2e;
                    text-decoration: underline;
                }
            }

            .fansk {
                margin-top: 30px;
                margin-left: 32px;
            }

            .dsadf {
                color: #3d9aff;
            }
        }

        .btnsearch {
            display: flex;
            flex-direction: row;
            align-items: center;

            .left {
                margin-right: 150px;
            }

            .right {
                margin-top: 27px;
            }
        }
    }
</style>